import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import {
  APOLITIRIO,
  APOLITIRIODIMITIKOU,
  APOLITIRIOGIMNASIOU,
  INITIAL_SUBMIT,
  NAUTICALPDBLUE,
  NAUTICALPDRED,
  RESUBMITTED,
} from "../../../constants";
import React, { useState } from "react";
import { ThumbDown, ThumbUp } from "@material-ui/icons";
import {
  fetchApplicationDocuments,
  updateApplicationDocument,
} from "../../../services/applicationDocuments";
import { useMutation, useQuery } from "react-query";

import { Buffer } from "buffer";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import { TextField as FormikTextField } from "formik-material-ui";
import useLocale from "../../../hooks/useLocale";
import { sortOrderDocs } from "../../../utils/sortOrderDocuments";
import GovGrButton from "../../../components/GovGrButton";
import GovGrCard from "../../../components/GovGrCard";
import FileUpload from "../../../components/GovGrFileInput/FileUpload";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
});
// const DarkerDisabledTextField = withStyles({
//   root: {
//     marginTop: 15,
//     marginBottom: 15,
//     "& .MuiInputBase-root.Mui-disabled": {
//       color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
//     },
//   },
// })(TextField);

const ApplicantDocuments = React.memo(
  ({
    setFieldValue,
    errors,
    touched,
    values,
    id,
    currentStatus,
    viewOnly,
    nauticalPdColor,
    applicationKindId,
  }) => {
    const [error, setError] = useState("");
    const { t } = useLocale();
    const classes = useStyles();
    const { data, isError, isLoading, refetch } = useQuery(
      ["applicationDocumentsWithId", id],
      () => fetchApplicationDocuments(id)
    );

    const [selectedRow, setSelectedRow] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate } = useMutation(updateApplicationDocument, {
      onSuccess: (data) => {
        refetch();
      },
      onError: (error) => {
        switch (error) {
          default: {
            setError(t("A network error occured. Please try again later"));
          }
        }
      },
    });

    const handleUpdateItem = (id, stsFlg, reasonTxt) => {
      mutate({
        id: id,
        sts_flg: stsFlg,
        reason_txt: reasonTxt,
      });
    };

    //Checks for the dscr Apolitirio and changes the word
    const dataFilteredPDColor = data?.map((doc) => {
      // console.log(applicationKindId);
      // console.log(doc);
      if (doc.DocDescription.includes(APOLITIRIO)) {
        if (nauticalPdColor === NAUTICALPDBLUE) {
          return { ...doc, DocDescription: APOLITIRIOGIMNASIOU };
        } else if (nauticalPdColor === NAUTICALPDRED) {
          return { ...doc, DocDescription: APOLITIRIODIMITIKOU };
        } else {
          return { ...doc };
        }
      } else {
        return { ...doc };
      }
    });
    const dataFilteredAndSorted = sortOrderDocs(
      dataFilteredPDColor,
      applicationKindId
    );

    // const currentDocument = (rowData) => {
    //   values.uploadedDocuments?.find(
    //     (doc) => doc?.doc_id === docPerKind.doc_id
    //   );
    // }


    return (
      <>
        <div className={classes.root}>
          <GovGrCard>
            <Typography variant="h3" color="textPrimary" gutterBottom>
              {t("Applicant Documents")}
            </Typography>
            <div>
              <CustomAlert
                open={isError}
                close={() => {
                  refetch();
                }}
                message={t("A network error occured, please try again later")}
              />

              <CustomTable
                options={{
                  showTitle: false,
                }}
                isLoading={isLoading}
                columns={[
                  {
                    title: t("Document"),
                    field: "DocDescription",
                    width: "150px",
                  },
                  {
                    title: t("Filename"),
                    field: "file_name",
                    width: "100px",
                  },
                  {
                    title: t("File"),
                    field: "doc_data",
                    render: (rowData) => {
                      return (
                        <GovGrButton
                          onClick={() => {
                            const blob = new Blob(
                              [new Uint8Array(rowData?.doc_data?.data)],
                              {
                                type: rowData?.content_type,
                              }
                            );
                            // console.log(new Uint8Array(rowData?.doc_data?.data));
                            if (navigator.userAgent.match(/firefox|fxios/i)) {
                              let url = window.URL.createObjectURL(blob);
                              window.open(url, "_blank");
                            } else {
                              // console.log("view file admin");
                              // console.log(rowData?.doc_data?.data);
                              // console.log(blob);
                              let url = window.URL.createObjectURL(blob);
                              window.open(url, "_blank");
                              // let a = document.createElement("a");
                              // a.href = url;
                              // // a.download = rowData?.file_name;
                              // a.click();
                            }
                          }}
                          variant="secondary"
                          buttonText={t("View")}
                        />
                      );
                    },
                    width: "100px",
                  },
                  // {
                  //   title: t("Upload file"),
                  //   field: "doc_data",
                  //   render: (rowData) => {
                  //     return (
                  //       // <GovGrButton
                  //       //   onClick={() => {
                  //       //     const blob = new Blob(
                  //       //       [new Uint8Array(rowData?.doc_data?.data)],
                  //       //       {
                  //       //         type: rowData?.content_type,
                  //       //       }
                  //       //     );
                  //       //     if (navigator.userAgent.match(/firefox|fxios/i)) {
                  //       //       let url = window.URL.createObjectURL(blob);
                  //       //       window.open(url, "_blank");
                  //       //     } else {
                  //       //       let url = window.URL.createObjectURL(blob);
                  //       //       window.open(url, "_blank");
                  //       //       // let a = document.createElement("a");
                  //       //       // a.href = url;
                  //       //       // // a.download = rowData?.file_name;
                  //       //       // a.click();
                  //       //     }
                  //       //   }}
                  //       //   variant="secondary"
                  //       //   buttonText={t("Upload file")}
                  //       // />
                  //       <>


                  //         <Card
                  //           key={rowData?.id}
                  //           variant="outlined"
                  //           className={classes.cardContent}
                  //         >
                  //           <CardContent>
                  //             {/* {rowData?.doc_id} */}
                  //             <FileUpload
                  //               label={""}
                  //               document={rowData}
                  //               errorLabel={""}

                  //               handleViewFile={() => {
                  //               }}
                  //               handleDeleteFile={() => {
                  //               }}

                  //               disableViewButton={true}
                  //               // disabled={disabledDoc()}
                  //               disableDeleteButton={!rowData?.new && rowData?.sts_flg !== 2}
                  //               onChange={(e) => {
                  //               }}
                  //               uploadedFilename={""}
                  //             // uploadedFilename={values?.uploadedDocuments
                  //             //   ?.filter((doc) => doc.doc_id === rowData.doc_id)
                  //             //   ?.map((doc) => {
                  //             //     if (!doc.new) {
                  //             //       return (
                  //             //         <p key={doc.file_name}>{doc.file_name}</p>
                  //             //       );
                  //             //     } else {
                  //             //       return doc.files.map((file) => (
                  //             //         <p key={file.name}>{file.name}</p>
                  //             //       ));
                  //             //     }
                  //             //   })}


                  //             />

                  //             {/* <FileUpload
                  //               label={`${index + 1}. ${rowData.dscr}`}
                  //               document={currentDocument}
                  //               accept={
                  //                 isPhoto ? "image/*" : "application/pdf,image/jpeg"
                  //               }
                  //               hint={isPhoto && t("Photo Requirements")}
                  //               errorLabel={error}
                  //               handleViewFile={() => {
                  //                 if (currentDocument.new) {
                  //                   const blob = new Blob(
                  //                     [currentDocument?.files[0]],
                  //                     {
                  //                       type: currentDocument?.files[0].type,
                  //                     }
                  //                   );

                  //                   let url = window.URL.createObjectURL(blob);

                  //                   window.open(url, "_blank");
                  //                 } else {
                  //                   if (currentDocument?.doc_data?.data) {
                  //                     const blob = new Blob(
                  //                       [
                  //                         Buffer.from(
                  //                           currentDocument?.doc_data?.data
                  //                         ),
                  //                       ],
                  //                       {
                  //                         type: "application/pdf",
                  //                       }
                  //                     );
                  //                     let url = window.URL.createObjectURL(blob);

                  //                     window.open(url, "_blank");
                  //                   }
                  //                 }
                  //               }}
                  //               handleDeleteFile={() => {
                  //                 const foundDocIndex =
                  //                   values?.uploadedDocuments?.findIndex(
                  //                     (uploadedDoc) =>
                  //                       uploadedDoc.doc_id === rowData.doc_id
                  //                   );

                  //                 arrayHelpers.remove(foundDocIndex);
                  //               }}
                  //               onChange={(e) =>
                  //                 isPhoto
                  //                   ? handleImageUpload(
                  //                     e,
                  //                     values,
                  //                     rowData,
                  //                     setImageFormatErrorText,
                  //                     arrayHelpers,
                  //                     t
                  //                   )
                  //                   : handleFileUpload(
                  //                     e,
                  //                     values,
                  //                     rowData,
                  //                     arrayHelpers
                  //                   )
                  //               }
                  //               disableViewButton={!currentDocument}
                  //               disabled={disabledDoc()}
                  //               disableDeleteButton={!currentDocument?.new && initialDocument?.sts_flg !== 2}
                  //               uploadedFilename={values?.uploadedDocuments
                  //                 ?.filter((doc) => doc.doc_id === rowData.doc_id)
                  //                 ?.map((doc) => {
                  //                   if (!doc.new) {
                  //                     return (
                  //                       <p key={doc.file_name}>{doc.file_name}</p>
                  //                     );
                  //                   } else {
                  //                     return doc.files.map((file) => (
                  //                       <p key={file.name}>{file.name}</p>
                  //                     ));
                  //                   }
                  //                 })}
                  //             /> */}






                  //           </CardContent>

                  //         </Card>


                  //         {/* <Card
                  //           key={docPerKind.id}
                  //           variant="outlined"
                  //           className={classes.cardContent}
                  //         >
                  //           <CardContent>
                  //             <FileUpload
                  //               label={`${index + 1}. ${docPerKind.dscr}`}
                  //               document={currentDocument}
                  //               accept={
                  //                 isPhoto ? "image/*" : "application/pdf,image/jpeg"
                  //               }
                  //               hint={isPhoto && t("Photo Requirements")}
                  //               errorLabel={error}
                  //               handleViewFile={() => {
                  //                 if (currentDocument.new) {
                  //                   const blob = new Blob(
                  //                     [currentDocument?.files[0]],
                  //                     {
                  //                       type: currentDocument?.files[0].type,
                  //                     }
                  //                   );

                  //                   let url = window.URL.createObjectURL(blob);

                  //                   window.open(url, "_blank");
                  //                 } else {
                  //                   if (currentDocument?.doc_data?.data) {
                  //                     const blob = new Blob(
                  //                       [
                  //                         Buffer.from(
                  //                           currentDocument?.doc_data?.data
                  //                         ),
                  //                       ],
                  //                       {
                  //                         type: "application/pdf",
                  //                       }
                  //                     );
                  //                     let url = window.URL.createObjectURL(blob);

                  //                     window.open(url, "_blank");
                  //                   }
                  //                 }
                  //               }}
                  //               handleDeleteFile={() => {
                  //                 const foundDocIndex =
                  //                   values?.uploadedDocuments?.findIndex(
                  //                     (uploadedDoc) =>
                  //                       uploadedDoc.doc_id === docPerKind.doc_id
                  //                   );

                  //                 arrayHelpers.remove(foundDocIndex);
                  //               }}
                  //               onChange={(e) =>
                  //                 isPhoto
                  //                   ? handleImageUpload(
                  //                     e,
                  //                     values,
                  //                     docPerKind,
                  //                     setImageFormatErrorText,
                  //                     arrayHelpers,
                  //                     t
                  //                   )
                  //                   : handleFileUpload(
                  //                     e,
                  //                     values,
                  //                     docPerKind,
                  //                     arrayHelpers
                  //                   )
                  //               }
                  //               disableViewButton={!currentDocument}
                  //               disabled={disabledDoc()}
                  //               disableDeleteButton={!currentDocument?.new && initialDocument?.sts_flg !== 2}
                  //               uploadedFilename={values?.uploadedDocuments
                  //                 ?.filter((doc) => doc.doc_id === docPerKind.doc_id)
                  //                 ?.map((doc) => {
                  //                   if (!doc.new) {
                  //                     return (
                  //                       <p key={doc.file_name}>{doc.file_name}</p>
                  //                     );
                  //                   } else {
                  //                     return doc.files.map((file) => (
                  //                       <p key={file.name}>{file.name}</p>
                  //                     ));
                  //                   }
                  //                 })}
                  //             />
                  //           </CardContent>
                  //         </Card> */}















                  //       </>
                  //     );
                  //   },
                  //   width: "100px",
                  // },
                  {
                    title: t("Rejection reason"),
                    field: "reason_txt",
                    width: "100px",
                  },
                  {
                    title: t("Status"),
                    field: "sts_flg",
                    render: (rowData) => (
                      <span>
                        {rowData.sts_flg === 1 ? (
                          <span style={{ color: "#006400" }}>
                            {t("Approved")}
                          </span>
                        ) : null}
                        {rowData.sts_flg === 2 ? (
                          <span style={{ color: "#8B0000" }}>
                            {t("Rejected")}
                          </span>
                        ) : null}
                        {rowData.sts_flg === 3 ? (
                          <span style={{ color: "#ff4500" }}>
                            {t("Pending")}
                          </span>
                        ) : null}
                      </span>
                    ),
                    width: "100px",
                  },
                ]}
                data={dataFilteredAndSorted}
                actions={[
                  {
                    disabled:
                      currentStatus === INITIAL_SUBMIT ||
                      currentStatus === RESUBMITTED ||
                      viewOnly,
                    icon: () => (
                      <ThumbUp
                        htmlColor={
                          currentStatus === INITIAL_SUBMIT ||
                            currentStatus === RESUBMITTED ||
                            viewOnly
                            ? "#DCDCDC"
                            : "#006400"
                        }
                      />
                    ),
                    tooltip: t("Approve"),
                    onClick: (event, rowData) => {
                      handleUpdateItem(rowData.id, 1, null);
                    },
                  },
                  {
                    disabled:
                      currentStatus === INITIAL_SUBMIT ||
                      currentStatus === RESUBMITTED ||
                      viewOnly,
                    icon: () => (
                      <ThumbDown
                        htmlColor={
                          currentStatus === INITIAL_SUBMIT ||
                            currentStatus === RESUBMITTED ||
                            viewOnly
                            ? "#DCDCDC"
                            : "#8B0000"
                        }
                      />
                    ),
                    tooltip: t("Reject"),
                    onClick: (event, rowData) => {
                      setSelectedRow(rowData);
                      setIsModalOpen(true);
                    },
                  },
                ]}
              />
            </div>
          </GovGrCard>

          <Dialog
            maxWidth="lg"
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            <DialogTitle id="reason-dialog-title">
              {t("Rejection reason")}
            </DialogTitle>
            <DialogContent>
              <Formik
                initialValues={{ reason_txt: "" }}
                onSubmit={(values, { setSubmitting }) => {
                  handleUpdateItem(selectedRow.id, 2, values.reason_txt);
                  setSubmitting(false);
                  setIsModalOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  setFieldValue,
                  touched,
                  errors,
                  values,
                  resetForm,
                }) => (
                  <Form>
                    <DialogContent>
                      <Field
                        className={classes.commentInput}
                        name="reason_txt"
                        component={FormikTextField}
                        variant="outlined"
                        multiline
                        fullwidth
                        margin="normal"
                        rows={5}
                        label={t("Rejection reason")}
                      />
                    </DialogContent>
                    <DialogActions>
                      <GovGrButton
                        onClick={submitForm}
                        buttonText={t("Update")}
                      />

                      <GovGrButton
                        onClick={() => {
                          setIsModalOpen(false);
                          setSelectedRow(null);
                        }}
                        buttonText={t("Close")}
                      />
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  }
);

export default ApplicantDocuments;
